import { DefaultVariant } from "./DefaultVariant";
import { MyMenuVariant } from "./MyMenuVariant";

type DefaultVariantProps = {
  variant?: "default";
};

type MyMenuVariantProps = {
  variant: "my-menu";
};

type BottomTabBarProps = DefaultVariantProps | MyMenuVariantProps;

export const BottomTabBar = (props: BottomTabBarProps) => {
  const Content = () => {
    switch (props.variant) {
      case "my-menu":
        return <MyMenuVariant />;
      case "default":
      default:
        return <DefaultVariant />;
    }
  };
  return <Content />;
};
